
import { Vue } from "vue-class-component";

export default class CheckGreenFill extends Vue {}
